import { render } from "./TextWithIcon.vue?vue&type=template&id=1e97d7c1"
import script from "./TextWithIcon.vue?vue&type=script&lang=js"
export * from "./TextWithIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__